"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

var ASSET_TYPES = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function initialState(type) {
  var base = {
    "class": 'asset',
    type: type,
    // 'agriculture', 'business', 'financial', 'other', 'personal', 'property', 'vehicle'
    subType: null,
    // Enums depend on type. check constants. OPTIMIZE: type2?
    subTypeOtherDescription: null,
    value: null,
    valueOwned: null,
    portionOwned: null,
    valueLiens: null,
    // OPTIMIZE: Relates to claims. Should be stored in a relationship to a claim, but on the asset for now
    additionalDescription: null,
    // Catch all for more info
    // SOFA - Seized Property (see above ref)
    seizure: null,
    closedAt: null,
    accountNumber: null,
    // Schedule C
    exemptions: [],
    // Insurance Policies
    beneficiary: null // NOTE: some party

  };

  if (type === ASSET_TYPES.PROPERTY) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      interest: null,
      // 'debtor_1', 'debtor_2', 'both', 'one_and_another'
      interestDescription: null,
      // nature of ownership interest explanation
      community: false,
      address: null
    });
  } else if (type === ASSET_TYPES.VEHICLE) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      interest: null,
      // 'debtor_1', 'debtor_2', 'both', 'one_and_another'
      interestDescription: null,
      // nature of ownership interest explanation
      community: false,
      make: null,
      model: null,
      year: null,
      estimatedMileage: null
    });
  } else if (type === ASSET_TYPES.FINANCIAL) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      party: null,
      // Ex) Name and info about financial institution
      accessibleBy: null // Party that also has access to asset

    });
  } else if (type === ASSET_TYPES.BUSINESS) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      name: null,
      // Ex) Name/Address of Org
      address: null,
      accessibleBy: null,
      // Accountant
      ein: null,
      startedAt: null,
      endedAt: null
    });
  }

  return base;
}

var createAsset = function createAsset(type, attrs) {
  return _objectSpread(_objectSpread(_objectSpread({}, initialState(type)), {}, {
    type: type
  }, attrs), {}, {
    id: (0, _v["default"])()
  });
};

var _default = createAsset;
exports["default"] = _default;